















import Vue from 'vue'

import TaskType from '../enums/taskType'

export default Vue.extend({
  name: 'OfferTaskList',

  props: {
    taskTypes: {
      type: Array,
      required: true,
    },
  },

  computed: {
    getTaskList() {
      return Object.values(TaskType).reduce((reducer: object[], task: any) => {
        if (!this.taskTypes.includes(task.type)) return reducer

        reducer.push(task)

        return reducer
      }, [])
    },
  },
})
